import { render } from "./environment.vue?vue&type=template&id=5df9e806&scoped=true"
import script from "./environment.vue?vue&type=script&lang=js"
export * from "./environment.vue?vue&type=script&lang=js"

import "./environment.vue?vue&type=style&index=0&id=5df9e806&scoped=scoped&lang=css"
script.render = render
script.__scopeId = "data-v-5df9e806"

export default script